export const SlashCircleIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <line stroke="currentColor" strokeLinecap="round" strokeWidth={2} x1={5.64} x2={18.36} y1={5.64} y2={18.36} />
  </svg>
);
